import { DBG_COLUMN_IDS, DBG_COLUMNS, transformDBGToRow } from '~components/Tables/DeviceTables/rowTransformers';
import { DBGWithType } from '~modules/devices/components/DeviceHealthTable/types';
import { dbgSortAccessors } from './sortAccessors';
import { BaseTableConfig, WithTransformer, WithColumnManager } from '../types';

export const planeDevicesTableConfig: BaseTableConfig & WithTransformer<DBGWithType> & WithColumnManager<DBGWithType> =
  {
    tableId: 'plane-devices',
    columns: DBG_COLUMNS,
    columnIds: DBG_COLUMN_IDS,
    transformRow: transformDBGToRow,
    sortAccessors: dbgSortAccessors,
    defaultOrderBy: 'device_type',
    defaultAscOrder: true,
  };
